module.exports = __webpack_public_path__ + "resources/img/img_equipment2.6b4a0182276d6d98a941a8380763fa88.png";